module.exports = __webpack_public_path__ + "img/wind_y.b5639eff.png";